import { ReturnRequestDto } from "@babackapp/private-api-client/types";
import { createContext, PropsWithChildren, useContext } from "react";

const CurrentReturnRequestContext = createContext<ReturnRequestDto | null>(
  null,
);

export function useCurrentReturnRequest() {
  const context = useContext(CurrentReturnRequestContext);

  if (!context)
    throw new Error(
      "useCurrentReturnRequest must be used within a CurrentReturnRequestProvider",
    );

  return context;
}

type Props = {
  returnRequest: ReturnRequestDto;
};

export function CurrentReturnRequestProvider({
  children,
  returnRequest,
}: PropsWithChildren<Props>) {
  return (
    <CurrentReturnRequestContext.Provider value={returnRequest}>
      {children}
    </CurrentReturnRequestContext.Provider>
  );
}
